import { useRouter } from "@tanstack/react-router";

export function useLocation() {
  return useRouter().state.location;
}
